<script setup lang="ts">
  import { Alert } from "@/components/ui/alert"

  import { useMoveOutSummary } from "@/views/myaccount/moving-home/useMoveOutSummary"

  const moveOutSummary = useMoveOutSummary()
</script>

<template>
  <Alert variant="success" role="status" data-testid="move-out-scheduled-alert">
    {{ moveOutSummary }}
  </Alert>
</template>
